import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { PreClearanceCategoriesTable } from '@app/components/apps/PreClearanceCategories/PreClearanceCategoryTable';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';

const AllPreClearanceCategories: React.FC = () => {
  const { setBreadcrumb, addHeaderButton, removeHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();

  function handleCreateClick(): void {
    navigate('/add-pre-clearance-category');
  }

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[{ path: '/pre-clearance-categories', breadcrumbName: 'Pre-Clearance Categories' }]}
        style={{ marginBottom: '15px' }}
      />,
    );

    addHeaderButton(
      'Add Pre-Clearance Category',
      <BaseButton type="primary" size="small" onClick={handleCreateClick}>
        Create
      </BaseButton>,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, []);

  return (
    <>
      <PageTitle>Pre-Clearance Categories</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <PreClearanceCategoriesTable />
        </Col>
      </Row>
    </>
  );
};

export default AllPreClearanceCategories;
